(function () {
  'use strict';

  document.addEventListener(
    'click',
    function (event) {
      if (window.innerWidth > 1024) return;

      const target = event.target;

      if (!(target instanceof Element)) return;

      const toggle = target.closest('.aloro-mobile-menu-toggle');

      if (!toggle) return;

      const menuItem = toggle.closest('.menu__item--aloro-mega');

      if (!menuItem) return;

      const submenu = menuItem.querySelector(
        ':scope > .aloro-mega-menu'
      );

      if (!submenu) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const isOpen = menuItem.classList.contains(
        'aloro-mobile-open'
      );

      const currentMenu = menuItem.closest('.js-menu');

      /*
       * Close other open Aloro mega menus
       */
      if (currentMenu) {
        currentMenu
          .querySelectorAll(
            '.menu__item--aloro-mega.aloro-mobile-open'
          )
          .forEach(function (otherItem) {
            if (otherItem === menuItem) return;

            otherItem.classList.remove('aloro-mobile-open');

            const otherToggle = otherItem.querySelector(
              ':scope > .aloro-mobile-menu-toggle'
            );

            if (otherToggle) {
              otherToggle.setAttribute(
                'aria-expanded',
                'false'
              );
            }
          });
      }

      /*
       * Toggle current mega menu
       */
      menuItem.classList.toggle(
        'aloro-mobile-open',
        !isOpen
      );

      toggle.setAttribute(
        'aria-expanded',
        isOpen ? 'false' : 'true'
      );
    },
    true
  );
})();